import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Box, Tooltip } from '@mui/material';
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOff as HighlightOffIcon,
} from '@mui/icons-material';
import { Selection } from 'components';
import { NumberFormatCustom } from 'components';

const InputItem = React.forwardRef(
  (
    { item, index, onDelete, onAdd, values, setValues, disabledField, surChargeListByFeeGroupId },
    ref,
  ) => {
    const [surchargeId, setSurchargeId] = React.useState('');
    const [inputPrice, setInputPrice] = React.useState(0);
    const [outputPrice, setOutputPrice] = React.useState(0);
    const [vat, setVat] = React.useState(0);

    React.useImperativeHandle(ref, () => ({
      getAlert() {
        alert('getAlert from Child');
      },
    }));
    React.useEffect(() => {
      setSurchargeId(item.surchargeId);
      setInputPrice(item.inputPrice);
      setOutputPrice(item.outputPrice);
      setVat(item.vat);
    }, [item]);

    const onChangeSurCharge = React.useCallback(
      (e) => {
        setSurchargeId(e.target.value);
        setValues((prev) => {
          prev[index].surchargeId = e.target.value;
          return [...prev];
        });
      },
      [surchargeId],
    );

    const onChangeOutputPrice = React.useCallback(
      (e) => {
        setOutputPrice(+e.target.value);
        setValues((prev) => {
          prev[index].outputPrice = +e.target.value;
          return [...prev];
        });
      },
      [outputPrice],
    );
    const onChangeInputPrice = React.useCallback(
      (e) => {
        setInputPrice(+e.target.value);
        setValues((prev) => {
          prev[index].inputPrice = +e.target.value;
          return [...prev];
        });
      },
      [inputPrice],
    );
    const onChangeVAT = React.useCallback(
      (e) => {
        setVat(+e.target.value);
        setValues((prev) => {
          prev[index].vat = +e.target.value;
          return [...prev];
        });
      },
      [vat],
    );
    const isDisabled = !surchargeId || !inputPrice || !outputPrice;

    return (
      <Container>
        <ContainerBody>
          <Box sx={{ width: '100%', marginRight: '10px' }}>
            <Selection
              required
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Mô tả"
              name="serviceId"
              onChange={onChangeSurCharge}
              value={surchargeId}
              dataArrObject={surChargeListByFeeGroupId}
              fieldValue="surchargeId"
              fieldView="surchargeName"
              error={!surchargeId}
              disabled={disabledField}
            />
            {!surchargeId && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <StyledTextFieldPrice
              label="Đơn giá xuất"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangeOutputPrice}
              value={outputPrice}
              error={!outputPrice}
              disabled={disabledField}
            />
            {!outputPrice && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <StyledTextFieldPrice
              label="Đơn giá nhập"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangeInputPrice}
              value={inputPrice}
              error={!inputPrice}
              disabled={disabledField}
            />
            {!inputPrice && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <StyledTextField
            label="VAT"
            variant="outlined"
            type="text"
            size="small"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            onChange={onChangeVAT}
            value={vat}
            disabled={disabledField}
          />
        </ContainerBody>
        <ContainerAction>
          {index === values.length - 1 ? (
            <>
              <Tooltip title="Xóa" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={() => onDelete(index)}
                  sx={{ borderColor: 'error.main' }}
                  disabled={disabledField}
                >
                  <HighlightOffIcon sx={{ color: 'error.main' }} />
                </ButtonWrapper>
              </Tooltip>
              <Tooltip title="Thêm" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={onAdd}
                  sx={{ borderColor: isDisabled ? 'action.disabled' : 'success.main' }}
                  disabled={isDisabled}
                >
                  <AddCircleOutlineIcon
                    sx={{ color: isDisabled ? 'action.disabled' : 'success.main' }}
                  />
                </ButtonWrapper>
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Xóa" arrow>
              <ButtonWrapper
                onClick={() => onDelete(index)}
                sx={{ borderColor: 'error.main' }}
                marginBottom={isDisabled ? '15px' : '0px'}
              >
                <HighlightOffIcon sx={{ color: 'error.main' }} />
              </ButtonWrapper>
            </Tooltip>
          )}
        </ContainerAction>
      </Container>
    );
  },
);
export default InputItem;

const StyledTextFieldPrice = styled(TextField)(({ theme }) => ({
  marginRight: '10px',
  width: '95%',
}));
const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '50%',
}));
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}));
const ContainerBody = styled(Box)(({ theme }) => ({
  width: '95%',
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
}));
const ContainerAction = styled(Box)(({ theme }) => ({
  width: '5%',
  display: 'flex',
  flexDirection: 'row',
}));
const ButtonWrapper = styled(Box)(({ theme, disabled = false, marginBottom = '10px' }) => ({
  marginBottom,
  pointerEvents: disabled ? 'none' : 'all',
  paddingInline: '6px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '0 4px 4px 0',
}));
const ErrorText = styled('div')(({ theme }) => ({
  color: 'red',
  fontSize: '12px',
  marginLeft: '10px',
}));
